
<a href="#" onclick="return false;" data-action="toggle" data-class="nav-function-minify" class="hidden-md-down">
  <i class="ni ni-chevron-right"></i>
  <i class="ni ni-chevron-right"></i>
</a>
